import React, { useEffect } from 'react';

/**
 * Internal dependencies.
 */
import './_product-badge.scss';

// Language
import { useTranslation } from 'react-i18next';

const ProductBadge = (props) => {
  const { t } = useTranslation();

  // Gestione sicura delle props con valori di default
  const badge = props.data || '';
  const badgeSize = props.size || ''; // sm empty
  const { className, ...atomProps } = props;

  // Mappa dei badge per una gestione più pulita e scalabile
  const badgeTextMap = {
    'eop': t("End of Production"),
    'phase_out': t("Phase Out"),
    'new': t("New")
  };

  // Ottieni il testo del badge dalla mappa o usa un valore di default
  const badgeText = badge && badgeTextMap[badge] ? badgeTextMap[badge] : '';

  // set atom class
  const badgeTooltipStatus = badge === 'phase_out' ? 'tip-active' : '';
  const atomClassName = 'badge ' + badge + ' ' + badgeSize + ' ' + badgeTooltipStatus;
  const atomClass = className !== undefined ? atomClassName + ' ' + className : atomClassName;

  // Utilizziamo useEffect invece di useLayoutEffect per maggiore compatibilità con SSR
  useEffect(() => {
    // Verifica che siamo in un ambiente client-side
    if (typeof window !== 'undefined') {
      // Verifica che bootstrap sia disponibile
      if (window.bootstrap && typeof window.bootstrap.Tooltip === 'function') {
        try {
          // only visible on product page
          const tooltipTriggerList = document.querySelectorAll('#pdp-desc [data-bs-toggle="tooltip"].tip-active');

          if (tooltipTriggerList && tooltipTriggerList.length > 0) {
            const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl =>
              new window.bootstrap.Tooltip(tooltipTriggerEl)
            );
          }
        } catch (error) {
          // Gestione sicura degli errori
          console.error('Error initializing tooltips:', error);
        }
      }
    }
  }, []); // Esegui solo al primo render

  return (
    <div
      comp="prod-badge"
      className={atomClass}
      {...atomProps}
      data={badge} // Aggiungiamo l'attributo data per debugging
      data-bs-toggle="tooltip"
      data-bs-placement="right"
      data-bs-custom-class="no-arrow"
      data-bs-title={badge === 'phase_out' ? t('Il prodotto verrà dismesso nei prossimi mesi') : ''}
    >
      {badgeText}
    </div>
  );
};

export default ProductBadge;
